export const wave = [
  0.3, 0.8, 1.3, 2, 1.8, 1.5, 1, 1, 1.5, 0.8, 0.8, 0.3, 0.3, 0.8, 1.3, 2, 1.8,
  1.5, 1, 1, 1.5, 0.8, 0.8, 0.3, 0.3, 0.8, 1.3, 2, 1.8, 1.5, 1, 1, 1.5, 0.8,
  0.8, 0.3, 0.3, 0.8, 1.3, 2, 1.8, 1.5, 1, 1,
].map((el) => el / 3);
